import { c as _c } from "react/compiler-runtime";
import { Stack } from '@mui/material';
import type { BackupVault, RestoreAccount } from '@repo/api-gw-sdk';
import { VaultOwnBucketCopyableAllAccountsPolicy, VaultOwnBucketCopyablePolicy } from '@/components/vaults/vaultOwnBucketCopyablePolicy';
import { VaultOwnBucketEditKeyPolicyButton } from '@/components/vaults/vaultOwnBucketEditKeyPolicyButton';
export const OwnBucketSuggestedPolicyDialogBody = t0 => {
  const $ = _c(10);
  const {
    backupVault,
    restoreAccounts
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      paddingX: "40px",
      gap: "24px",
      alignItems: "flex-end"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== backupVault.vaultAttributes.aws?.bucketName || $[2] !== restoreAccounts) {
    t2 = restoreAccounts ? <VaultOwnBucketCopyablePolicy bucketName={backupVault.vaultAttributes.aws?.bucketName || ""} restoreAccounts={restoreAccounts} /> : <VaultOwnBucketCopyableAllAccountsPolicy bucketName={backupVault.vaultAttributes.aws?.bucketName || ""} />;
    $[1] = backupVault.vaultAttributes.aws?.bucketName;
    $[2] = restoreAccounts;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = backupVault.vaultAttributes.aws?.bucketName || "";
  let t4;
  if ($[4] !== backupVault.region || $[5] !== t3) {
    t4 = <VaultOwnBucketEditKeyPolicyButton region={backupVault.region} bucketName={t3} />;
    $[4] = backupVault.region;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t2 || $[8] !== t4) {
    t5 = <Stack sx={t1}>{t2}{t4}</Stack>;
    $[7] = t2;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};